import { Boundaries } from "@planzone/core";
import { Gantt } from "@planzone/dto";

function handleRemoveConstraintRequest(
  gantt: Gantt,
  constraint: Boundaries["removeConstraint"]["request"],
): Gantt {
  return {
    ...gantt,
    constraints: gantt.constraints.filter(
      ({ uuid }) => uuid !== constraint.uuid,
    ),
  };
}

function handleRemoveConstraintSuccess(
  gantt: Gantt,
  constraint: Boundaries["removeConstraint"]["success"],
): Gantt {
  return {
    ...gantt,
    constraints: gantt.constraints.filter(
      ({ uuid }) => uuid !== constraint.uuid,
    ),
  };
}

function handleRemoveConstraintFailure(
  gantt: Gantt,
  constraint: Boundaries["removeConstraint"]["failure"],
): Gantt {
  return {
    ...gantt,
    constraints: [...gantt.constraints, constraint],
  };
}

export {
  handleRemoveConstraintRequest,
  handleRemoveConstraintSuccess,
  handleRemoveConstraintFailure,
};
